import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchAssessments, updateAssessment } from '../store/assessmentsSlice';
import CustomInput from '../components/CustomInput';
import { useFormik } from 'formik';
import * as yup from "yup";
import { Col, Modal, Row, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import CreateUpdateQuestions from './CreateUpdateQuestions';
import CustomBreadcrumb from '../components/CustomBreadcrumb';
import TabTitle from '../components/TabTitle';
import CustomButton from '../components/CustomButton';

const EditAssessment = () => {
    const { id } = useParams();
    const assessment_id = id;
    const dispatch = useDispatch();
    const { assessments, loading, error } = useSelector((state) => state.assessments);
    const [assessment, setAssessment] = useState({});
    const user = useSelector((state) => state.users.singleRecord?.data);
    const companyId = user?.company;

    useEffect(() => {
        const queryParams = { assessment_id: assessment_id, company_id: companyId  };
        dispatch(fetchAssessments(queryParams));  // Dispatch the fetchUsers action to get data
    }, [dispatch, assessment_id, companyId]);

    useEffect(() => {
        if (assessments && assessments?.data?.length > 0) {
            setAssessment(assessments?.data?.[0]);
        } else setAssessment({});
    }, [assessments, assessment?.questions?.length, loading, error]);


    const createAssessmentValidationSchema = yup.object({
        name: yup
            .string("Please enter name")
            .required("Please enter name"),
        description: yup
            .string("Please enter description")
            .required("Please enter description"),
        passing_perc: yup
            .string("Please enter passing percentage")
            .required("Please enter passing percentage"),
    });

    useEffect(() => {
        if (assessment) {
            createAssessmentFormik.setValues({
                name: assessment?.name,
                description: assessment?.description,
                passing_perc: assessment?.passing_perc,
            });
        }
    }, [assessment]);

    const createAssessmentFormik = useFormik({
        initialValues: {
            name: assessment?.name,
            description: assessment?.description,
            passing_perc: assessment?.passing_perc,
        },
        validationSchema: createAssessmentValidationSchema,
        onSubmit: async (values) => {
            try {
                await dispatch(updateAssessment({ ...values, assessment_id: assessment_id })).unwrap();
                toast.success('Assessment updated successfully');
            } catch (error) {
                console.log(error, "error");
            }
        }
    });

    const {
        values: createAssessmentValues,
        errors: createAssessmentErrors,
        touched: createAssessmentTouched,
        handleBlur: createAssessmentHandleBlur,
        handleChange: createAssessmentHandleChange,
        handleSubmit: createAssessmentHandleSubmit,
        isSubmitting: createAssessmentIsSubmitting,
    } = createAssessmentFormik;

    const breadcrumbList = [
        { title: "Assessments", href: "/admin/assessments/" },
        { title: "Update assessment", href: "" },
    ];


    return (
        <div>
            <TabTitle title="Edit Assessment" />
            <CustomBreadcrumb breadcrumbList={breadcrumbList} />
            {loading ? <div className='custom-loader'><Spinner animation="border" variant="success" /></div> : <>
                <div className="main-content mb-5">
                    <div className="container-fluid bg-white form-box">
                        <h2 className='main-title'>Assessment</h2>
                        <Row>
                            <Col lg={6}>
                                <CustomInput name="name" label="Name" type="textarea" placeholder="Name" required error={createAssessmentTouched?.passing_perc && Boolean(createAssessmentErrors?.name)} errorText={createAssessmentTouched?.name && createAssessmentErrors?.name} onChange={createAssessmentHandleChange} onBlur={createAssessmentHandleBlur} value={createAssessmentValues.name} />
                            </Col>
                            <Col lg={6}>
                                <CustomInput name="description" label="Description" type="textarea" placeholder="Description" required error={createAssessmentTouched?.passing_perc && Boolean(createAssessmentErrors?.description)} errorText={createAssessmentTouched?.description && createAssessmentErrors?.description} onChange={createAssessmentHandleChange} onBlur={createAssessmentHandleBlur} value={createAssessmentValues.description} />
                            </Col>
                            <Col lg={6}>
                                <CustomInput name="passing_perc" label="Passing Precentage" type="number" placeholder="Passing Precentage" required error={createAssessmentTouched?.passing_perc && Boolean(createAssessmentErrors?.passing_perc)} errorText={createAssessmentTouched?.passing_perc && createAssessmentErrors?.passing_perc} onChange={createAssessmentHandleChange} onBlur={createAssessmentHandleBlur} value={createAssessmentValues.passing_perc} />
                            </Col>
                        </Row>
                        <Modal.Footer className='justify-content-center'>
                            <CustomButton name="Update" minWidth="110px" disabled={createAssessmentIsSubmitting} onClick={createAssessmentHandleSubmit} isLoading={createAssessmentIsSubmitting} />
                        </Modal.Footer>
                    </div>
                </div>
                <CreateUpdateQuestions assessment_id={assessment_id} data={assessment?.questions?.length > 0 ? assessment?.questions : []} />
            </>}
        </div>
    );
}

export default EditAssessment;